module.exports = __webpack_public_path__ + "static/media/carrot.19388095.png";